import React from 'react';

import HomePageSkeleton from '../../components/skeleton/HomePageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const HOME_PAGE_CHUNK_NAME = 'homePage';

export const HomePage = createRouteLoadable(
  () => import(/* webpackChunkName: "homePage" */ '../../pages/HomePage'),
  {
    fallback: <HomePageSkeleton />,
  }
);
